export const SIDENAV_TOGGLE = "SIDENAV_TOGGLE"